<template>
    <slot v-if="accepted"></slot>
    <div v-else class="cookie-policy-holder ">
        <div class="cookie-policy-content d-shadow-light">
            <div class="cookie-icon" v-html="dicons.common_icons.cookie"></div>
            <div class="relative">
                <div class="text-center">
                    <h3><d-text>Cookie_Policy_Title</d-text></h3>
                </div>
                <div class="my-3 text-center">
                    <p><d-text>Cookie_Policy_Text</d-text></p>
                </div>
                <div class="mb-3 mt-5 text-center">
                    <d-button @click="Deny" class="m-1" variant="outline-danger"><d-text>Button_Deny</d-text></d-button>
                    <d-button @click="Accept" class="m-1"
                        variant="outline-warning"><d-text>Button_Accept_Necessary</d-text></d-button>
                    <d-button @click="Accept" class="m-1"
                        variant="success"><d-text>Button_Accept_All</d-text></d-button>
                </div>
            </div>
        </div>
        <d-modal hideok id="DenyCookieModal" center title="Deny_Cookie_Modal_Title" ref="DenyCookieModalRef">
            <div>
                <d-text>Cookie_Policy_Explained_Text</d-text>
            </div>
        </d-modal>
    </div>
</template>

<script setup>

import dicons from './../enums/dicons';
import { ref, defineProps, computed } from 'vue'
import { useCookieStore } from '@/dod/store/dcookie'
const cStore = useCookieStore();

defineProps({
    id: { type: String },
    image: { type: String}
})

const DenyCookieModalRef = ref(null);

const accepted = computed(() => cStore.accepted);

// functions
function Deny() {
    DenyCookieModalRef.value.Open();
}

function Accept() {
    cStore.setAccept();
}

</script>

<style>
.cookie-policy-holder {
    margin: 0 auto;
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 100vh;
}

.cookie-policy-content {
    position: relative;
    background-color: var(--white);
    border-radius: var(--border-radius);
    max-width: 800px;
    padding: 60px;
    overflow: hidden;
}

.cookie-icon {
    fill: var(--bs-primary);    
    position: absolute;
    opacity: 0.08;
    bottom: -50px;
    right: -50px;    
    width: 350px;
    height: 350px;
}
</style>